// Generated by CoffeeScript 2.7.0
var SettingsAttendance;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

export default SettingsAttendance = Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },
  props: {
    activeTab: {
      type: String
    },
    attendance: {
      type: Object
    },
    currentIp: {
      type: String
    }
  },
  data: function() {
    return {
      settingsAttendance: this._generateAttendance(),
      updateDisabled: false
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="form-field-group field-list-two-item inline">
      <div class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">签到功能</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <label class="switch">
              <input type="checkbox"
                     v-model="settingsAttendance.attendance_enable">
              <span></span>
            </label>
          </div>
          <div class="message"></div>
        </div>
      </div>
      <div class="form-field"></div>
    </div>
    <div class="form-field-group field-list-two-item inline"
         :class="{'disabled': !settingsAttendance.attendance_enable}">
      <div class="form-field inline">
        <div class="form-field-head">
          <div class="form-field-title">认证IP</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input type="text"
                   :disbaled="!settingsAttendance.attendance_enable"
                   v-model.trim="settingsAttendance.certificated_ip">
          </div>
          <div class="message"></div>
        </div>
      </div>
      <div class="form-field inline">
        <div class="form-field-input-container">
          <div class="form-field-input">
            <button class="btn btn-primary"
                    :class="{'disabled': !settingsAttendance.attendance_enable}"
                    @click="getCurrentIp">使用当前ip</button>
          </div>
        </div>
      </div>
    </div>
    <div class="content-footer">
      <button class="content-footer-btn"
              :disabled="updateDisabled"
              @click="updateSettings">更新</button>
    </div>
  </template>
</settings-container>`,
  methods: {
    updateSettings: function() {
      var data;
      this.updateDisabled = true;
      data = {
        namespace: {
          attendance_enable: this.settingsAttendance.attendance_enable,
          certificated_ip: this.settingsAttendance.certificated_ip
        }
      };
      return Skylark.Libs.Ajax.patch('/admin/settings/attendance.json', {
        data: data,
        responseType: 'json',
        contentType: 'application/json; charset=utf-8',
        success: function(data) {
          return Skylark.Bridge.newAlertify('更新成功', {
            type: 'success'
          });
        },
        error: function(xhr, status, err) {
          return Skylark.Bridge.newAlertify('更新失败', {
            type: 'danger'
          });
        },
        complete: () => {
          return this.updateDisabled = false;
        }
      });
    },
    getCurrentIp: function() {
      return this.settingsAttendance.certificated_ip = this.currentIp;
    },
    _generateAttendance: function() {
      return {
        attendance_enable: this.attendance.attendance_enable,
        certificated_ip: this.attendance.certificated_ip
      };
    }
  }
});
